var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3776,
    cy: 14.4924,
    r: 3.34444,
    stroke: "#3479B2",
    strokeWidth: 0.97886
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9005 23.4109H15.8552C19.3346 23.4109 21.0743 23.4109 22.324 22.591C22.865 22.2361 23.3295 21.78 23.691 21.2489C24.526 20.0219 24.526 18.3139 24.526 14.8978C24.526 11.4817 24.526 9.7736 23.691 8.54663C23.3295 8.01546 22.865 7.55939 22.324 7.20448C21.521 6.67768 20.5156 6.48938 18.9765 6.42208C18.242 6.42208 17.6096 5.87562 17.4655 5.16848C17.2494 4.10776 16.3008 3.34424 15.1991 3.34424H11.5566C10.4549 3.34424 9.50629 4.10776 9.29022 5.16848C9.14617 5.87562 8.51377 6.42208 7.77927 6.42208C6.24009 6.48938 5.23477 6.67768 4.43176 7.20448C3.89076 7.55939 3.42625 8.01546 3.06476 8.54663C2.22974 9.7736 2.22974 11.4817 2.22974 14.8978C2.22974 18.3139 2.22974 20.0219 3.06476 21.2489C3.42625 21.78 3.89076 22.2361 4.43176 22.591C5.68146 23.4109 7.42114 23.4109 10.9005 23.4109Z",
    stroke: "#3479B2",
    strokeWidth: 0.97886
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1815 11.1479H20.0667",
    stroke: "#3479B2",
    strokeWidth: 0.97886,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.5269be1cb965d7508533f2d54de7c83d.svg";
export { ForwardRef as ReactComponent };